import { render, staticRenderFns } from "./DataConsumptionPollView.vue?vue&type=template&id=63b5f166&lang=html&"
import script from "./DataConsumptionPollView.vue?vue&type=script&lang=ts&"
export * from "./DataConsumptionPollView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports